module.exports = __webpack_public_path__ + "static/media/hands_14.d04e21a6.svg";